var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2503 30.1269C38.9978 27.1567 40 23.6954 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 23.6954 1.00226 27.1568 2.74978 30.1271L13.9269 18.9499C14.5654 18.3152 15.5965 18.3152 16.2351 18.9499L23.2577 25.9726L27.0227 22.2075C27.6612 21.5728 28.6923 21.5728 29.3309 22.2075L37.2503 30.1269ZM35.033 33.1916H4.96698C8.63247 37.3654 14.0086 40 20 40C25.9914 40 31.3675 37.3654 35.033 33.1916ZM24.8947 16.8218C27.6069 16.8218 29.8056 14.6232 29.8056 11.9109C29.8056 9.1987 27.6069 7 24.8947 7C22.1825 7 19.9838 9.1987 19.9838 11.9109C19.9838 14.6232 22.1825 16.8218 24.8947 16.8218Z",
    fill: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryDefaultImage);
export default __webpack_public_path__ + "static/media/CategoryDefaultImage.7445e9d22aa38295c8ed9715075775b4.svg";
export { ForwardRef as ReactComponent };